export default __webpack_public_path__ + "static/kleine-kompressoren_boge-c-2_baureihe-0ddb463d393c29e0356f1ee7801652e7.png";